import {jwtDecode} from 'jwt-decode';
import { Token } from "../models/token.model";
var CryptoJS = require("crypto-js");
 



export class AppStorage{
    private getKey() : string{
        var token = sessionStorage.getItem('ACCESS_TOKEN');
        var decoded = jwtDecode(token as string) as Token; 
        return decoded.userKey;
    }

    public userHasSession() : boolean{
        var token = sessionStorage.getItem('ACCESS_TOKEN');
        return token !== null;
    }
    private encrypt(data : string) {
        this.getKey();
        data = CryptoJS.AES.encrypt(JSON.stringify({data}), this.getKey());
        data = data.toString();
        return data;
    }

    private decrypt(data : string){
        this.getKey();
        var decryptedData = CryptoJS.AES.decrypt(data, this.getKey());
        var result = decryptedData.toString(CryptoJS.enc.Utf8);
        var resultToReturn = JSON.parse(result);
        return resultToReturn.data;
    }

    public getItem(key : string) : string{
        return this.decrypt(localStorage.getItem(key) as string);
    }
    public isKeyExists(key: string) : boolean{
        var item = localStorage.getItem(key);
        return item !== null ? true : false;
    }
    public setItem(key: string, string : string) : void{
        return localStorage.setItem(key, this.encrypt(string));
    }
    clearStore(){
        localStorage.clear();
    }
    clear(){
        localStorage.clear();
        sessionStorage.clear();
    }

}